export default __webpack_public_path__ + "images/BK.a906e88.png";